import axios, {
  AxiosInstance,
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
  AxiosHeaders,
} from 'axios';
import { toast } from 'react-toastify';
import store from '../core/redux/store';
import { setProgress } from '../core/redux/commonSlice';
import { useEffect, useState } from 'react';
import { end_points } from './endpoints';

const hostName = window.location.hostname;
const apiUrl = `https://${hostName}/admin/api`;
console.log('Host Name:', hostName);

const API_URL =
  //hostName !== 'localhost' ? apiUrl : 'https://tharun.bestatservices.com/api';
  // hostName !== 'localhost'
  //   ? apiUrl
  //   : 'https://client.test-cst.dreamstechnologies.com/admin/api';
  // hostName !== 'localhost' ? apiUrl : 'http://tharun.webshop.test/api';
  hostName !== 'localhost' ? apiUrl : 'https://madinahdryclean.com/admin/api';
// hostName !== 'localhost' ? apiUrl : 'https://laundry-lounge.co.uk/admin/api'
// ;
// hostName !== 'localhost'
// hostName !== 'localhost'
//   ? apiUrl
//   : 'https://laundrylounge.test-cst.dreamstechnologies.com/admin/api';
//   ? apiUrl
//   : 'https://royallaunderette.test-cst.dreamstechnologies.com/admin/api';
// Create Axios instances
export const axiosInstanceWithToken: AxiosInstance = axios.create({
  baseURL: API_URL,
});
const axiosInstance: AxiosInstance = axios.create({ baseURL: API_URL });

let progressInterval: NodeJS.Timeout | null = null;

/**
 * Simulate Progressive Loading
 */
const startProgress = () => {
  store.dispatch(setProgress(0));
  progressInterval = setInterval(() => {
    const currentProgress = store.getState().common.progress;
    if (currentProgress < 95) {
      store.dispatch(setProgress(currentProgress + 5));
    }
  }, 300);
};

const stopProgress = () => {
  if (progressInterval) {
    clearInterval(progressInterval);
    progressInterval = null;
  }
  store.dispatch(setProgress(100));
  setTimeout(() => store.dispatch(setProgress(0)), 500); // Reset after 0.5s
};

/**
 * Set Request Headers
 */
const setRequestHeaders = async (
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  const token = store.getState().common.token;
  const locationString = localStorage.getItem('location');
  const location = locationString ? JSON.parse(locationString) : null;

  const FormDataUrls = [
    end_points.address.url,
    end_points.forgotPassword.url,
  ].filter(Boolean);

  const isFormData = config.url
    ? FormDataUrls.some((url: any) => config.url.startsWith(url))
    : false;

  config.headers = new AxiosHeaders({
    ...config.headers,
    Authorization: token ? `Bearer ${token}` : '',
    'Access-Control-Allow-Origin': '*',

    'Content-Type': isFormData ? 'multipart/form-data' : 'application/json',
    Accept: 'application/json',
  });

  return config;
};

/**
 * Request Interceptor
 */
axiosInstance.interceptors.request.use(
  async (config) => {
    // store.dispatch(setLoading(true));
    startProgress();
    return setRequestHeaders(config);
  },
  (error) => {
    // store.dispatch(setLoading(false));
    stopProgress();
    return Promise.reject(error);
  }
);

/**
 * Response Interceptor
 */
const handleResponse = async (response: AxiosResponse) => {
  // store.dispatch(setLoading(false));
  stopProgress();
  handleResponseStatus(response);
  return response;
};

const handleError = async (error: AxiosError) => {
  // store.dispatch(setLoading(false));
  stopProgress();

  if (!error.response) {
    //toast.error('Network error. Please check your connection.');
    return Promise.reject(error);
  }

  handleResponseStatus(error.response);
  return Promise.reject(error.response);
};

// Apply Interceptors to both instances
axiosInstance.interceptors.response.use(handleResponse, handleError);
axiosInstanceWithToken.interceptors.response.use(handleResponse, handleError);

/**
 * Handles response status codes and shows appropriate messages
 */
const handleResponseStatus = async (response: AxiosResponse) => {
  toast.clearWaitingQueue();
  const { status, data } = response;

  const showToast = (message: string) =>
    toast.error(message, {
      className: 'custom-toast-error',
      progressClassName: 'custom-toast-progress-error',
    });

  switch (status) {
    case 200:
      break;
    case 201:
      if (data?.message) {
        toast.success(data.message, {
          className: 'custom-toast-success',
          progressClassName: 'custom-toast-progress-success',
        });
      }
      break;
    case 400:
      showToast(data?.message || 'Bad request. Please check your input.');
      break;
    case 401:
      showToast(data?.message || 'Unauthorized. Please login again.');
      break;
    case 402:
      showToast(data?.message || data?.data?.message || 'Payment required.');
      break;
    case 404:
      showToast(data?.message || 'Resource not found.');
      break;
    case 409:
      showToast(data?.message || 'Conflict error.');
      break;
    case 410:
      showToast(data?.message || 'Resource is no longer available.');
      break;
    case 422: {
      const validationError = data?.validation?.[0]?.msg || data?.message;
      if (Array.isArray(validationError)) {
        showToast(validationError[0]?.msg || 'Unprocessable entity.');
      } else {
        showToast(validationError);
      }
      break;
    }
    case 500:
      showToast('Internal server error. Please try again later.');
      break;
    default:
      showToast('Unexpected error occurred.');
      break;
  }
};

export default axiosInstance;
